// src/components/Common/Footer.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import './ClientFooter.scss';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="footer-client mt-5">
      <p>{t('developed_by')} Venture Global Services © 2022.</p>
    </footer>
  );
};

export default Footer;
